<a
  href="javascript:void(0);"
  class="btn btn-icon btn-circle btn-success btn-scroll-to-top fade"
  data-click="scroll-top"
  (click)="scrollToTop()"
  ><i class="fas fa-angle-up"></i
></a>
